import { motion } from "framer-motion";

/**
 * Reveal — Framer Motion scroll reveal.
 * Smoothly animates children up from below as they enter the viewport.
 * API-compatible with the previous component (children, as, delay, className).
 */
const Reveal = ({
  children,
  as = "div",
  delay = 0,
  y = 28,
  duration = 0.9,
  once = true,
  amount = 0.2,
  className = "",
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  // delay can be passed in milliseconds (legacy) or seconds. Normalise.
  const delaySec = delay > 5 ? delay / 1000 : delay;

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount, margin: "0px 0px -8% 0px" }}
      transition={{
        duration,
        delay: delaySec,
        ease: [0.16, 1, 0.3, 1],
      }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
